// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1nf5L","topBottomGutter":"Layout_topBottomGutter__2MzEp"};